import { useTranslation } from "react-i18next";
import { DropdownMenu, Button, Text } from "@radix-ui/themes";
import { Languages } from "lucide-react";
import { SUPPORTED_LANGUAGES, type LanguageCode } from "@/lib/i18n";

interface LanguageSwitcherProps {
  /** Affiche uniquement l'icône si true, icône + label si false */
  compact?: boolean;
}

export function LanguageSwitcher({ compact = false }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation();

  // Langue active — fallback sur FR si code non reconnu
  const current =
    SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language) ??
    SUPPORTED_LANGUAGES[0];

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Button
          variant="ghost"
          size="1"
          color="gray"
          aria-label={t("language.label")}
        >
          <Languages size={14} />
          {!compact && (
            <Text size="1" style={{ marginLeft: 4 }}>
              {current.label}
            </Text>
          )}
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <DropdownMenu.Item
            key={lang.code}
            onSelect={() => i18n.changeLanguage(lang.code as LanguageCode)}
            style={{
              fontWeight: i18n.language === lang.code ? "600" : "normal",
            }}
          >
            {lang.flag}&nbsp;{lang.label}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
